var _path, _path2, _ellipse, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriends(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1821 21.876C19.8146 21.8616 24.6038 24.4478 26.3641 30.0149C22.8159 32.1779 18.6393 33.011 14.1821 33.0002C9.72484 33.011 5.54824 32.1779 2 30.0149C3.76239 24.4418 8.5435 21.8616 14.1821 21.876Z",
    stroke: "#00B268",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.017 28.2248C29.4205 28.2331 32.6097 27.597 35.3191 25.9453C33.9749 21.6943 30.3179 19.7195 26.017 19.7305C23.3077 19.7236 20.8577 20.5011 19.0781 22.1389",
    stroke: "#00B268",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.1833,
    cy: 8.63058,
    rx: 7.63058,
    ry: 7.63058,
    stroke: "#00B268",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7437 5.60041C22.8068 4.4862 24.3062 3.79199 25.9678 3.79199C29.1918 3.79199 31.8053 6.40553 31.8053 9.6295C31.8053 12.8535 29.1918 15.467 25.9678 15.467C23.997 15.467 22.2543 14.4903 21.1973 12.9946",
    stroke: "#00B268",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/friends.418e7e106b845094b2f91cd08acc48b6.svg";
export { ForwardRef as ReactComponent };